import { render, staticRenderFns } from "./SearchAdvanced.vue?vue&type=template&id=3b6145a8&scoped=true"
import script from "./SearchAdvanced.vue?vue&type=script&lang=ts"
export * from "./SearchAdvanced.vue?vue&type=script&lang=ts"
import style0 from "./SearchAdvanced.vue?vue&type=style&index=0&id=3b6145a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6145a8",
  null
  
)

export default component.exports